import {AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ValidatorsBuilderService} from '../../../../validators/validators-with-message/eparcours-validators/validators-builder.service';
import {ItemCheckListModel} from '../../../../models/check-lists/check-list-model';

@Component({
  selector: 'app-add-new-item-checklist',
  templateUrl: './add-new-item-checklist.component.html',
  styleUrls: ['./add-new-item-checklist.component.scss'],
})
export class AddNewItemChecklistComponent implements OnInit, OnDestroy, AfterViewInit {
  formGroupChecklist: UntypedFormGroup;
  itemControl: UntypedFormControl;

  @Output() addItem: EventEmitter<ItemCheckListModel> = new EventEmitter<ItemCheckListModel>();

  @ViewChild('inputFocus') inputFocus: ElementRef;

  constructor(private formBuilder: UntypedFormBuilder, private validatorsBuilder: ValidatorsBuilderService) {}

  ngOnInit() {
    this.buildForm();
  }

  ngOnDestroy(): void {}

  ngAfterViewInit(): void {
    this.inputFocus.nativeElement.focus();
  }

  ajouterItem() {
    if (this.formGroupChecklist.valid) {
      this.addItem.emit({
        libelle: this.itemControl.value,
        estCoche: false,
      });
      this.itemControl.setValue(null);
    }
  }

  private buildForm() {
    this.itemControl = this.formBuilder.control(null, this.validatorsBuilder.required());
    this.formGroupChecklist = this.formBuilder.group({
      item: this.itemControl,
    });
  }
}
